import React, { useState, useRef } from 'react';
import { Grid, Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import { VideoComponent } from '../VideoComponent';
import { BlogCard } from '../BlogCard';

export interface ProductProps {
  product: {
    name: string;
    desc: string;
    blogs: {
      img: string;
      title: string;
      author: string;
      authorImg: string;
      date: string;
      duration: string;
      url: string;
    }[];
    video: {
      thumbnail: string;
      videoUrl: string;
    };
  };
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: '0 16px',
  },
  advantageSection: {
    display: 'flex',
    marginBottom: 64,
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  sectionTitle: {
    fontSize: 24,
    flex: '0.3',
    paddingRight: 32,
    [theme.breakpoints.down('md')]: {
      marginBottom: '24px',
    },
  },
  sectionContent: {
    fontSize: 16,
    flex: '0.7',
  },
  blogContent: {
    flex: '0.7',
    display: 'flex',
    [theme.breakpoints.down('md')]: {
      margin: '0 -16px',
      padding: '0 16px 16px',
      overflowX: 'auto',
      maxWidth: '100vw',
      scrollbarWidth: 'none',
      msOverflowStyle: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
}));

export const ProductAdvantagePanel = (props: ProductProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.advantageSection}>
        <div className={classes.sectionTitle}>What does it do?</div>
        <div className={classes.sectionContent}>{props.product.desc}</div>
      </div>
      <div className={classes.advantageSection}>
        <div className={classes.sectionTitle}>Demo Videos</div>
        <div className={classes.sectionContent}>
          <VideoComponent
            thumbnail={props.product.video.thumbnail}
            videoUrl={props.product.video.videoUrl}
            height="174px"
            width="294px"
          />
        </div>
      </div>
      <div className={classes.advantageSection}>
        <div className={classes.sectionTitle}>Related Blogs</div>
        <div className={classes.blogContent}>
          {props.product.blogs.map((blogItem) => (
            <BlogCard key={blogItem.title} data={blogItem} />
          ))}
        </div>
      </div>
    </div>
  );
};
